import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.grey[100],
  },
  grid: {
    paddingTop: '160px',
    zIndex: 1,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 0,
    },
  },
  input: ({ scrolled }) => {
    return scrolled ? ({ ...theme.typography.caption }) : ({ ...theme.typography.h6 })
  },
  legend: {
    display: 'block',
    color: theme.palette.grey['700'],
    marginTop: theme.spacing(1),
  },
  pagination: {
    marginBottom: theme.spacing(5),
  },
  containerInput: ({ scrolled }) => ({
    width: '92%',
    background: theme.palette.grey[100],
    position: 'fixed',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(7),
    zIndex: 2,
    '& > div': {
      background: scrolled ? 'white' : 'transparent',
      borderRadius: scrolled ? '20px' : 'unset',
      borderBottom: scrolled ? 'none' : `1px solid ${theme.palette.grey.A100}`,
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      position: 'relative',
    },
  }),
}))

export default useStyles
